import { testSettingConstants } from "../constants/testSettingConstants"
import { db } from "../../../mp-database"
import getTruthyKeys from "../../helpers/getTruthyKeys"
import getGroupType from "../../../mp-utils/generic-utils/common/getGroupType"

export const testSettingActions = {
  fetchDefaultTestSettings,
  fetchGroupTestSettings,
  saveTestControlSettings,
  getActiveTestSettings,
  findLevelAboveSettings
}

function fetchDefaultTestSettings() {
  return dispatch => {
    dispatch(request())
    try {
      db.collection("testSettings")
        .doc("globalDefault")
        .get()
        .then(doc => {
          if (doc.exists) {
            let defaults = doc.data()

            return dispatch(success(defaults))
          } else {
            //Create new global defaults in db
            let defaults = {
              id: "globalDefault",
              timingOptions: {
                standardTime: { enabled: true, settings: null },
                unlimitedTime: { enabled: false, settings: null },
                doubleTime: { enabled: false, settings: null },
                timeAndHalf: { enabled: false, settings: null },
                customTime: { enabled: false, settings: { value: 0 } }
              },
              modes: {
                resumeMode: { enabled: true, settings: null },
                singleSubjectMode: { enabled: true, settings: null },
                educatorStartMode: { enabled: false, settings: null },
                lockMode: { enabled: false, settings: null }
              },
              groupType: "Global"
            }

            db.collection("testSettings")
              .doc(defaults.id)
              .set(defaults)
              .then(() => dispatch(success(defaults)))
              .catch(err => dispatch(failure(err)))
          }
        })
        .catch(err => {
          return dispatch(failure(err))
        })
    } catch (err) {
      return dispatch(failure(err))
    }
  }

  function request() {
    return {
      type: testSettingConstants.FETCH_DEFAULT_TEST_SETTINGS
    }
  }
  function success(payload) {
    return {
      type: testSettingConstants.FETCH_DEFAULT_TEST_SETTINGS_SUCCESS,
      payload
    }
  }
  function failure(payload) {
    return {
      type: testSettingConstants.FETCH_DEFAULT_TEST_SETTINGS_FAILED,
      payload
    }
  }
}

function fetchGroupTestSettings(groupId, groupData, unSubscribe) {
  return dispatch => {
    const groupType = getGroupType(groupId, groupData)

    if (!groupType) return

    const queryKeys = {
      "School District": { key: "districtId", value: groupId },
      School: { key: "schoolId", value: groupId },
      Teacher: {
        key: "schoolId",
        value: groupData?.educators?.[groupId]?.school
      },
      Class: { key: `schoolId`, value: groupData?.educators?.[groupId]?.school }
    }

    const queryKey = queryKeys[groupType]
    if (!queryKey.value) return
    // if (groupType === "Class") {
    //   groupId = groupData.classes[groupId].teacher
    //   queryKey.key = "schoolId"
    //   queryKey.value
    // }

    dispatch(request())
    try {
      const call = db
        .collection("testSettings")
        // .where("groupType", "==", groupType)
        .where(queryKey.key, "==", queryKey.value)
        .onSnapshot(
          querySnapshot => {
            let groupSettings = {}
            querySnapshot.forEach(doc => {
              if (doc.exists) {
                groupSettings[doc.id] = doc.data()
              }
            })
            dispatch(success(groupSettings))
          },
          function (err) {
            dispatch(failure(err))
          }
        )

      if (unSubscribe) {
        unSubscribe(call)
      }
    } catch (err) {
      return dispatch(failure(err))
    }
  }

  function request() {
    return {
      type: testSettingConstants.FETCH_GROUP_TEST_SETTINGS
    }
  }
  function success(payload) {
    return {
      type: testSettingConstants.FETCH_GROUP_TEST_SETTINGS_SUCCESS,
      payload
    }
  }
  function failure(payload) {
    return {
      type: testSettingConstants.FETCH_GROUP_TEST_SETTINGS_FAILED,
      payload
    }
  }
}

function saveTestControlSettings(settings, callback) {
  return dispatch => {
    dispatch(request())
    const { id } = settings
    settings.lastUpdated = Date.now()

    try {
      db.collection("testSettings")
        .doc(id)
        .set(settings, { merge: true })
        .then(doc => {
          if (callback) {
            callback()
          }
          return dispatch(success(settings))
        })
        .catch(err => {
          return dispatch(failure(err))
        })
    } catch (err) {
      return dispatch(failure(err))
    }
  }

  function request() {
    return {
      type: testSettingConstants.SAVE_TEST_SETTINGS
    }
  }
  function success(payload) {
    return {
      type: testSettingConstants.SAVE_TEST_SETTINGS_SUCCESS,
      payload
    }
  }
  function failure(payload) {
    return {
      type: testSettingConstants.SAVE_TEST_SETTINGS_FAILED,
      payload
    }
  }
}

function getActiveTestSettings(user, unSubscribe) {
  return async dispatch => {
    dispatch(request())
    try {
      const foundSetting = await findActiveTestSettings(user)
      if (foundSetting) {
        const { id } = foundSetting
        const call = db
          .collection("testSettings")
          .doc(id)
          .onSnapshot(
            querySnapshot => {
              dispatch(success(querySnapshot.data()))
            },
            function (err) {
              dispatch(failure(err))
            }
          )

        if (unSubscribe) {
          unSubscribe(call)
        }
      } else {
        // No active test settings found
        return dispatch(success(null))
      }
    } catch (err) {
      return dispatch(failure(err))
    }
  }

  function request() {
    return {
      type: testSettingConstants.FETCH_ACTIVE_TEST_SETTINGS
    }
  }
  function success(payload) {
    return {
      type: testSettingConstants.FETCH_ACTIVE_TEST_SETTINGS_SUCCESS,
      payload
    }
  }
  function failure(payload) {
    return {
      type: testSettingConstants.FETCH_ACTIVE_TEST_SETTINGS_FAILED,
      payload
    }
  }
}

async function findActiveTestSettings(user) {
  const { id, classes, teachers, school, schoolDistrict } = user
  let classRecords = []
  let teacherRecords = []
  let schoolRecord
  let districtRecord

  const teacherIds = getTruthyKeys(teachers)

  //TODO REF -> https://gitlab.com/masteryprep/truscore/frontend/-/issues/248
  // const classIds = getTruthyKeys(classes)

  // classRecords = classIds.map(classId => {
  //   return db
  //     .collection("testSettings")
  //     .doc(classId)
  //     .get()
  // })

  // const classActiveSettings = await Promise.all(classRecords).then(settings => {
  //   const classSettings = []
  //   settings.forEach(settingDoc => {
  //     if (settingDoc.exists) {
  //       const setting = settingDoc.data()
  //       if (!setting.deleted) {
  //         classSettings.push(setting)
  //       }
  //     }
  //   })

  //   if (classSettings.length) {
  //     classSettings.sort((a, b) => b.lastUpdated - a.lastUpdated)
  //     return classSettings[0]
  //   } else {
  //     return null
  //   }
  // })

  // if (classActiveSettings) {
  //   return classActiveSettings
  // }

  teacherRecords = teacherIds.map(teacherId => {
    return db.collection("testSettings").doc(teacherId).get()
  })

  const teacherActiveSettings = await Promise.all(teacherRecords).then(
    settings => {
      const teacherSettings = []
      settings.forEach(settingDoc => {
        if (settingDoc.exists) {
          const setting = settingDoc.data()
          if (!setting.deleted) {
            teacherSettings.push(setting)
          }
        }
      })

      if (teacherSettings.length) {
        teacherSettings.sort((a, b) => b.lastUpdated - a.lastUpdated)
        return teacherSettings[0]
      } else {
        return null
      }
    }
  )

  if (teacherActiveSettings) {
    return teacherActiveSettings
  }

  schoolRecord = await db.collection("testSettings").doc(school).get()

  if (schoolRecord.exists) {
    schoolRecord = schoolRecord.data()
    if (!schoolRecord.deleted) {
      return schoolRecord
    }
  }

  districtRecord = await db.collection("testSettings").doc(schoolDistrict).get()

  if (districtRecord.exists) {
    districtRecord = districtRecord.data()
    if (!districtRecord.deleted) {
      return districtRecord
    }
  }
}

function findLevelAboveSettings(groupRecord, groupData) {
  return async dispatch => {
    try {
      dispatch(request())
      const { id } = groupRecord
      const groupType = getGroupType(id, groupData)

      //Specific records to look for
      let recordIds = []

      if (groupType === "Class") {
        const { teacher, school, district } = groupRecord
        recordIds = [teacher, school, district]
      }
      if (groupType === "Teacher") {
        const { school, schoolDistrict } = groupRecord
        recordIds = [school, schoolDistrict]
      }
      if (groupType === "School") {
        const { district } = groupRecord
        recordIds = [district]
      }

      let settings = {}

      for (let i = 0; i < recordIds.length; i++) {
        let findSettings = await db
          .collection("testSettings")
          .doc(recordIds[i])
          .get()

        if (findSettings.exists) {
          const foundSetting = findSettings.data()

          if (foundSetting.deleted) {
            continue
          }
          if (settings.timingOptions && settings.modes) {
            break
          }

          if (!settings.timingOptions && foundSetting.timingOptions) {
            settings = {
              ...settings,
              timingOptions: {
                ...foundSetting,
                groupType: getGroupType(recordIds[i], groupData)
              }
            }
          }

          if (!settings.modes && foundSetting.modes) {
            settings = {
              ...settings,
              modes: {
                ...foundSetting,
                groupType: getGroupType(recordIds[i], groupData)
              }
            }
          }
        }
      }
      dispatch(success(Object.keys(settings).length ? settings : null))
    } catch (err) {
      return dispatch(failure(err))
    }
  }

  function request() {
    return {
      type: testSettingConstants.FIND_LEVEL_ABOVE_TEST_SETTINGS
    }
  }
  function success(payload) {
    return {
      type: testSettingConstants.FIND_LEVEL_ABOVE_TEST_SETTINGS_SUCCESS,
      payload
    }
  }
  function failure(payload) {
    return {
      type: testSettingConstants.FIND_LEVEL_ABOVE_TEST_SETTINGS_FAILED,
      payload
    }
  }
}
